import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api/api.js'
Vue.prototype.$api = api

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '协和医院';
    }
    next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
